import styled from 'styled-components'

export const StyledSelect = styled.select`
  appearance: none;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 8px 32px 8px 12px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s ease;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' strokeLinecap='round' strokeLinejoin='round' strokeWidth='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 8px center;
  background-repeat: no-repeat;
  background-size: 16px;
  min-width: 140px;

  &:hover {
    border-color: #a855f7;
    box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.1);
  }

  &:focus {
    outline: none;
    border-color: #a855f7;
    box-shadow: 0 0 0 3px rgba(168, 85, 247, 0.2);
  }

  option {
    padding: 8px 12px;
    background: white;
    color: #374151;
  }
`

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledTotalCount = styled.div`
  padding: 8px 0;
  font-size: 14px;
  font-weight: 500;
  color: #6b7280;
  display: inline-flex;
  align-items: center;
  margin-right: auto;
`
